export { default, IAvatar } from './Avatar';
